interface ApiConstantsInterface {
  baseUrl: string
  commerceBaseUrl: string
  productSettings: string
  calendarSettings: string
  calendarTemplates: string
}

const apiConstants: ApiConstantsInterface = {
  baseUrl: '/api/admin',
  commerceBaseUrl: '/admin/api/commerce',
  productSettings: `/settings/product`,
  calendarSettings: `/calendarsettings`,
  calendarTemplates: `/calendar-templates`
}

export { apiConstants, ApiConstantsInterface }
